import { Card as MuiCard, CardContent, styled } from "@mui/material";

const StyledCard = styled(MuiCard)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  transition: "box-shadow 0.3s ease-in-out",
  "&:hover": {
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
  },
}));

const StyledCardContent = styled(CardContent)({
  padding: "12px 16px 16px",
  "&:last-child": {
    paddingBottom: "12px",
  },
});

const MinimalistCard = ({ children }) => {
  return (
    <StyledCard>
      <StyledCardContent>{children}</StyledCardContent>
    </StyledCard>
  );
};

export default MinimalistCard;
